import { render, staticRenderFns } from "./CoursesJobsTease.vue?vue&type=template&id=beb4edd6&"
import script from "./CoursesJobsTease.vue?vue&type=script&lang=js&"
export * from "./CoursesJobsTease.vue?vue&type=script&lang=js&"
import style0 from "./CoursesJobsTease.vue?vue&type=style&index=0&id=beb4edd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports